import { useCallback, useEffect, useState } from 'react';
import { getPremiacaoTabelaVeiculos } from '@spark/services/premiacao';
import { notification } from '@spark/ui-components/utils/notification';

export const usePremiacaoTabelaVeiculosVinculados = (tabelaPremiacaoId) => {
  const [veiculos, setVeiculos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(10);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const carregarVeiculos = useCallback(async () => {
    if (!tabelaPremiacaoId) {
      setVeiculos([]);
      setTotalRegistros(0);
      return;
    }

    try {
      setLoading(true);
      const response = await getPremiacaoTabelaVeiculos({
        PaginaAtual: paginaAtual,
        QuantidadePorPagina: quantidadePorPagina,
        IdTabelaPremiacao: tabelaPremiacaoId,
        Ativo: true
      });
      const data = response?.data || response || {};
      const lista = Array.isArray(data.registros) ? data.registros : [];

      setVeiculos(lista);
      setTotalRegistros(data.totalRegistros || lista.length);
    } catch (error) {
      console.error('Erro ao carregar veiculos vinculados:', error);
      notification.error(
        error?.message || 'Nao foi possivel carregar os veiculos vinculados',
        'Erro ao carregar veiculos'
      );
      setVeiculos([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  }, [tabelaPremiacaoId, paginaAtual, quantidadePorPagina]);

  useEffect(() => {
    setPaginaAtual(1);
  }, [tabelaPremiacaoId]);

  useEffect(() => {
    carregarVeiculos();
  }, [carregarVeiculos]);

  const handlePaginationChange = useCallback((paginationState) => {
    if (paginationState.pageSize !== quantidadePorPagina) {
      setQuantidadePorPagina(paginationState.pageSize);
      setPaginaAtual(1);
    } else if (paginationState.pageIndex !== undefined) {
      setPaginaAtual(paginationState.pageIndex + 1);
    }
  }, [quantidadePorPagina]);

  const reload = useCallback(() => {
    carregarVeiculos();
  }, [carregarVeiculos]);

  return {
    veiculos,
    loading,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handlePaginationChange,
    reload
  };
};
